import Create from './create/CreateProvider';
import Edit from './edit/EditProvider';
import Individual from './individual/Provider';
import List from './list/Providers';

export default {List, Individual, Edit, Create}